import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ScenarioType } from 'shared/enums/scenario-type';

interface IProps {
  scenarioType: ScenarioType;
}

export const ScenarioName = ({ scenarioType }: Readonly<IProps>): ReactElement => {
  const { t } = useTranslation('scenario');

  return <>{t(`scenarioName.${scenarioType}`)}</>;
};

export default ScenarioName;
